export default {"src":"/_next/static/media/modal_fntt_close_dark.329641a0.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};